import { render } from "./AcademicWeekendPrimary.vue?vue&type=template&id=8c58feae&scoped=true"
import script from "./AcademicWeekendPrimary.vue?vue&type=script&lang=js"
export * from "./AcademicWeekendPrimary.vue?vue&type=script&lang=js"

import "./AcademicWeekendPrimary.vue?vue&type=style&index=0&id=8c58feae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c58feae"]])

export default __exports__